// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recommendations-container {
    padding: 2rem;
    /* max-width: 1200px; */
    margin: 0 auto;
}

.recommendations-container h2 {
    text-align: center;
    color: #2c3e50;
    margin-bottom: 2rem;
    font-size: 2rem;
}
.recommendations-container p.note {
    margin-bottom: 20px;
    color: red;
    font-style: italic;

}

.universities-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    /* gap: 2rem; */
    /* padding: 1rem; */
}

.university-card {
    background: rgb(14, 11, 11);
    border-radius: 10px;
    padding: 1.5rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
}

.university-card:hover {
    /* transform: translateY(-5px); */
}

.university-card h3 {
    color: #1a73e8;
    margin-bottom: 1rem;
    font-size: 1.5rem;
}

.university-card p {
    color: #4a4a4a;
    margin: 0.5rem 0;
    line-height: 1.6;
}

.apply-button {
    background: #1a73e8;
    color: white;
    border: none;
    padding: 0.8rem 1.5rem;
    border-radius: 5px;
    margin-top: 1rem;
    cursor: pointer;
    transition: background 0.3s ease;
    width: 100%;
}

.apply-button:hover {
    background: #1557b0;
}

.blur-content {
    filter: blur(4px);
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
}
.payment-notice {
    margin: 40px 0;
    padding: 20px;
    border: 2px solid #1a73e8;
    border-radius: 8px;
    background: linear-gradient(to right, #f8fafc, #ffffff);
    box-shadow: 0 2px 10px rgba(26, 115, 232, 0.1);
}

.payment-notice h3 {
    margin: 0;
    text-align: center;
    color: #cb1111;
    font-size: 1.5rem;
    font-weight: 600;
    letter-spacing: 0.5px;
}


.recommendation-page {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  
  .page-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    /* max-width: 1200px; */
    width: 100%;
  }
  
  /* Left Section - Payment Box */
  .left-section {
    flex: 2 1;
    max-width: 350px;
  }
  
  .payment-box {
    background: #ffffff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .payment-box h2 {
    font-size: 24px;
    color: #444;
  }
  
  .payment-box p {
    margin: 10px 0;
    color: #666;
  }
  
  .price {
    font-size: 20px;
    font-weight: bold;
    color: #007bff;
  }
  
  .pay-now-btn {
    margin-top: 15px;
    padding: 10px 20px;
    background: #007bff;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
  }
  
  .pay-now-btn:hover {
    background: #0056b3;
  }
  
  /* Right Section - Dynamic Content */
  .right-section {
    flex: 2 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  /* Card and Google Meet Box */
  .card,
  .google-meet-box {
    background: linear-gradient(to right, #007bff, #0056b3);
    color: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    position: relative;
  }
  
  .card h3,
  .google-meet-box h3 {
    font-size: 20px;
    margin-bottom: 10px;
  }
  
  .card p,
  .google-meet-box p {
    font-size: 16px;
    margin: 5px 0;
  }
  
  /* Blurred Effect */
  .blurred {
    filter: blur(5px);
    position: relative;
    pointer-events: none;
  }
  
  .blurred::after {
    content: "Pay to Unlock";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 18px;
    font-weight: bold;
    color: white;
    text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    z-index: 1;
  }
  
  .blurred button {
    display: none;
  }
  .padding_40 {
    padding: 40px;
  }

  .recommendations-container h3 {
    text-align:center; 
    margin-bottom: 20px;
  }
  .recommendations-container .university-card p {
    color: #ffffff !important;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .page-container {
      flex-direction: column;
    }
  
    .left-section {
      max-width: 100%;
    }
  
    .right-section {
      max-width: 100%;
    }
    .university-card {
      max-width: 254px !important;
    }
    .padding_40 {
      padding: 12px !important;
    }
    .calendar-scheduler {
      padding: 1rem !important;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/Recommendations.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,uDAAuD;IACvD,8CAA8C;AAClD;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,WAAW;EACb;;EAEA,+BAA+B;EAC/B;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,oCAAoC;EACpC;IACE,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,6BAA6B;EAC7B;;IAEE,uDAAuD;IACvD,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,aAAa;EACf;;EAEA,mBAAmB;EACnB;IACE,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,uCAAuC;IACvC,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;IACA;MACE,2BAA2B;IAC7B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,wBAAwB;IAC1B;EACF","sourcesContent":[".recommendations-container {\n    padding: 2rem;\n    /* max-width: 1200px; */\n    margin: 0 auto;\n}\n\n.recommendations-container h2 {\n    text-align: center;\n    color: #2c3e50;\n    margin-bottom: 2rem;\n    font-size: 2rem;\n}\n.recommendations-container p.note {\n    margin-bottom: 20px;\n    color: red;\n    font-style: italic;\n\n}\n\n.universities-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    /* gap: 2rem; */\n    /* padding: 1rem; */\n}\n\n.university-card {\n    background: rgb(14, 11, 11);\n    border-radius: 10px;\n    padding: 1.5rem;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s ease;\n}\n\n.university-card:hover {\n    /* transform: translateY(-5px); */\n}\n\n.university-card h3 {\n    color: #1a73e8;\n    margin-bottom: 1rem;\n    font-size: 1.5rem;\n}\n\n.university-card p {\n    color: #4a4a4a;\n    margin: 0.5rem 0;\n    line-height: 1.6;\n}\n\n.apply-button {\n    background: #1a73e8;\n    color: white;\n    border: none;\n    padding: 0.8rem 1.5rem;\n    border-radius: 5px;\n    margin-top: 1rem;\n    cursor: pointer;\n    transition: background 0.3s ease;\n    width: 100%;\n}\n\n.apply-button:hover {\n    background: #1557b0;\n}\n\n.blur-content {\n    filter: blur(4px);\n    pointer-events: none;\n    user-select: none;\n}\n.payment-notice {\n    margin: 40px 0;\n    padding: 20px;\n    border: 2px solid #1a73e8;\n    border-radius: 8px;\n    background: linear-gradient(to right, #f8fafc, #ffffff);\n    box-shadow: 0 2px 10px rgba(26, 115, 232, 0.1);\n}\n\n.payment-notice h3 {\n    margin: 0;\n    text-align: center;\n    color: #cb1111;\n    font-size: 1.5rem;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n}\n\n\n.recommendation-page {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n  }\n  \n  .page-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    /* max-width: 1200px; */\n    width: 100%;\n  }\n  \n  /* Left Section - Payment Box */\n  .left-section {\n    flex: 2 1;\n    max-width: 350px;\n  }\n  \n  .payment-box {\n    background: #ffffff;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    text-align: center;\n  }\n  \n  .payment-box h2 {\n    font-size: 24px;\n    color: #444;\n  }\n  \n  .payment-box p {\n    margin: 10px 0;\n    color: #666;\n  }\n  \n  .price {\n    font-size: 20px;\n    font-weight: bold;\n    color: #007bff;\n  }\n  \n  .pay-now-btn {\n    margin-top: 15px;\n    padding: 10px 20px;\n    background: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n  }\n  \n  .pay-now-btn:hover {\n    background: #0056b3;\n  }\n  \n  /* Right Section - Dynamic Content */\n  .right-section {\n    flex: 2 1;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  /* Card and Google Meet Box */\n  .card,\n  .google-meet-box {\n    background: linear-gradient(to right, #007bff, #0056b3);\n    color: white;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    position: relative;\n  }\n  \n  .card h3,\n  .google-meet-box h3 {\n    font-size: 20px;\n    margin-bottom: 10px;\n  }\n  \n  .card p,\n  .google-meet-box p {\n    font-size: 16px;\n    margin: 5px 0;\n  }\n  \n  /* Blurred Effect */\n  .blurred {\n    filter: blur(5px);\n    position: relative;\n    pointer-events: none;\n  }\n  \n  .blurred::after {\n    content: \"Pay to Unlock\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 18px;\n    font-weight: bold;\n    color: white;\n    text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n    z-index: 1;\n  }\n  \n  .blurred button {\n    display: none;\n  }\n  .padding_40 {\n    padding: 40px;\n  }\n\n  .recommendations-container h3 {\n    text-align:center; \n    margin-bottom: 20px;\n  }\n  .recommendations-container .university-card p {\n    color: #ffffff !important;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .page-container {\n      flex-direction: column;\n    }\n  \n    .left-section {\n      max-width: 100%;\n    }\n  \n    .right-section {\n      max-width: 100%;\n    }\n    .university-card {\n      max-width: 254px !important;\n    }\n    .padding_40 {\n      padding: 12px !important;\n    }\n    .calendar-scheduler {\n      padding: 1rem !important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
